// src/store/index.js
import { createStore } from 'vuex'
import { persistState } from '@/plugins/persistState';


export const initialState = () => {
  return {
    isLoading: false,
    appointmentId: "",
    appointmentDateString: "",
    transactionDateString: "",
    activeTab: 1,
    selectSlot: {},
    appointmentAcknowlegement: {
      id: "", name: "", phoneNumber: "", email: "", serviceName: "", vehicleNumber: "", noticeNumber: "", vacNumber: "",
      parfNumber: "", coeNumber: "", tcoeNumber: "", hvParkNumber: "", deviceNumber: "", remarks: "", serviceId: "",
      referenceNumber: "", appointmentDateTime: "", postBookingMessage: "", waitingArea: "", generateDateTime: "",
      numberOfSlots: "", appointmentDate: "", startTime: "", endTime: "", cancelledRemark: "", oldPostBookingMessage: ""
    },
    newAppointment: {
      name: "", phoneNumber: "", email: "", serviceGroupId: "", categoryId: "", serviceId: "",
      appointmentDate: new Date(), startTime: "", endTime: "",
      vehicleNumber: "", noticeNumber: "", vacNumber: "", parfNumber: "", coeNumber: "", tcoeNumber: "",
      hvParkNumber: "", deviceNumber: "", remarks: "", serviceName: "", preBookingMessage: "",
      isShowContactDetails: true,
      isShowService: false,
      isShowServiceDetails: false,
      isShowNote: false
    },
    appointmentStore: {
      name: "", phoneNumber: "", email: "", serviceGroupId: "", categoryId: "", serviceId: "",
      appointmentDate: new Date(), startTime: "", endTime: "",
      vehicleNumber: "", noticeNumber: "", vacNumber: "", parfNumber: "", coeNumber: "", tcoeNumber: "",
      hvParkNumber: "", deviceNumber: "", remarks: "", serviceName: "", appointmentDate: "", startTime: "", endTime: "", numberOfSlots: ""
    },
  }
};

export const store = createStore({
  state: initialState(),
  mutations: {
    setLoading(state, loadingState) {
      state.isLoading = loadingState;
    },
    setAppointmentId(state, appointmentId) {
      state.appointmentId = appointmentId;
    },
    setselectedSlot(state, selectSlot) {
      state.selectSlot = selectSlot;
    },
    setAppointmentAcknowlegement(state, appointmentAcknowlegement) {
      state.appointmentAcknowlegement = appointmentAcknowlegement;
    },
    setMopAppointmentDetails(state, appointmentStore) {
      state.appointmentStore = appointmentStore;
    },
    setNewAppointMent(state, newAppointment) {
      state.newAppointment = newAppointment;
    },
    setAppointmentDateString(state, appointmentDateString) {
      state.appointmentDateString = appointmentDateString;
    },
    setTransactionDateString(state, transactionDateString) {
      state.transactionDateString = transactionDateString;
    },
    setActiveTab(state, activeTab) {
      state.activeTab = activeTab;
    },
    reset(state) {
      const s = initialState();
      Object.assign(state, s);
    }
  },
  actions: {
    setLoading({ commit }, loadingState) {
      commit('setLoading', loadingState);
    },
    setAppointmentId({ commit }, appointmentId) {
      commit('setAppointmentId', appointmentId)
    },
    setselectedSlot({ commit }, selectSlot) {
      commit('setselectedSlot', selectSlot)
    },
    setAppointmentAcknowlegement({ commit }, appointmentAcknowlegement) {

      commit('setAppointmentAcknowlegement', appointmentAcknowlegement)
    },
    setMopAppointmentDetails({ commit }, appointmentStore) {

      commit('setMopAppointmentDetails', appointmentStore)
    },
    setNewAppointMent({ commit }, newAppointment) {
      commit('setNewAppointMent', newAppointment)
    },
    setAppointmentDateString({ commit }, appointmentDateString) {
      commit('setAppointmentDateString', appointmentDateString)
    },
    setTransactionDateString({ commit }, transactionDateString) {
      commit('setTransactionDateString', transactionDateString)
    },
    setActiveTab({ commit }, activeTab) {
      commit('setActiveTab', activeTab)
    },
    reset({ commit }) {
      commit('reset');
    }

  },
  getters: {
    getAppointmentId: state => state.appointmentId,
    getAppointmentAcknowlegement: state => state.appointmentAcknowlegement,
    getMopAppointmentDetails: state => state.appointmentStore,
    getNewAppointment: state => state.newAppointment,
    getAppointmentDateString: state => state.appointmentDateString,
    getTransactionDateString: state => state.transactionDateString,
    getActiveTab: state => state.activeTab,
    getselectedSlot: state => state.selectSlot,
  },
  plugins: [persistState],
})
